<template>
    <modal :show="show">
        <div slot="modalHeader">
          <modal-header :closeModal="close">Are you sure?</modal-header>
        </div>
      Are you sure you want to clone this creative?
        <div slot="modalFooter">
          <modal-footer :closeModal="close" :confirm="confirm" cancelText="No, go back" confirmText="Yes"/>
        </div>
    </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'modal_clone_creative',
  mixins: [modalMixin, campaignMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta
  },
  props: {
    show: Boolean,
    creativeId: String
  },
  data: () => ({}),
  mounted () {
  },
  computed: {},
  methods: {
    confirm () {
      this.startLoading()
      this.cloneCreative({creativeId: this.creativeId}).then(() => {
        this.addNotification('success', `Creative successfully cloned.`)
        const id = this.$route.params.id
        this.getCreatives(id).then(() => {
          this.finishLoading()
        }, error => {
          this.finishLoading()
          this.addNotification('danger', error)
        })
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
      this.close()
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-clone-creative.vue